import { SpacerContainer } from "./elements/SpacerContainer";

interface SpacerProps {
  height?: number | string;
  width?: number | string;
  minHeight?: number | string;
  minWidth?: number | string;
}

export const Spacer: React.FC<SpacerProps> = ({
  height: heightRaw,
  width: widthRaw,
  minHeight: minHeightRaw,
  minWidth: minWidthRaw,
}) => {
  const height = typeof heightRaw === "number" ? `${heightRaw}px` : heightRaw;
  const width = typeof widthRaw === "number" ? `${widthRaw}px` : widthRaw;
  const minHeight = typeof minHeightRaw === "number" ? `${minHeightRaw}px` : minHeightRaw;
  const minWidth = typeof minWidthRaw === "number" ? `${minWidthRaw}px` : minWidthRaw;

  return (
    <SpacerContainer height={height} width={width} minHeight={minHeight} minWidth={minWidth} />
  );
};
